// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"15d75a39","228":"b187f729","343":"2cad60a1","468":"99a32f4d","478":"f0a9d787","553":"cb366e13","576":"8532076e","596":"f64d689e","778":"e08c7b1c","992":"a5a2acf9"}[chunkId] + ".chunk.js";
};